import config from '../../config'

type CookiebotConsentState = {
  preferences?: boolean
  statistics?: boolean
  marketing?: boolean
}

type CookiebotApi = {
  consent?: CookiebotConsentState
  renew?: () => void
  show?: () => void
  withdraw?: () => void
}

declare global {
  interface Window {
    Cookiebot?: CookiebotApi
  }
}

class CookiebotClient {
  isEnabled = () => Boolean(config.cookiebotDomainGroupId)

  hasStatisticsConsent = () => {
    if (!this.isEnabled()) return true
    if (typeof window === 'undefined') return false

    return Boolean(window.Cookiebot?.consent?.statistics)
  }

  hasMarketingConsent = () => {
    if (!this.isEnabled()) return true
    if (typeof window === 'undefined') return false

    return Boolean(window.Cookiebot?.consent?.marketing)
  }
}

export default new CookiebotClient()
